
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkUserLanguageEnum } from '../models/work-user-language-enum';

export function getUpdateLanguageDtoFormGroup() {
return new FormGroup({
    language: new FormControl<WorkUserLanguageEnum | undefined>(undefined, [Validators.required]),
})
;
}
      